import { GetApp } from "../../App"
import { CloseButton } from "../../Components/CloseButton"
import { DetailsToggle } from "../../Components/DetailsToggle"
import { CruiseTitleViewProps } from "./Params"

export function CruiseTitleView({ cruise, onDetailsChange, onClose }: CruiseTitleViewProps) {
  const app = GetApp();
  const t = app.getT("CruiseView");

  return (
    <div className="CruiseView-title">
      <DetailsToggle onChange={onDetailsChange} />
      <span className="title">{cruise.title || t("untitled_cruise")}</span> {cruise.startedAt && (
        <span className="CruiseView-date-range">
          ({cruise.startedAt && app.format("date", cruise.startedAt)} - {cruise.completedAt ? app.format("date", cruise.completedAt) : ""})
        </span>
      )}
      {<CloseButton onClick={onClose} />}
    </div>
  );
}
